import { isAxiosError } from 'axios';

import { HttpStatus } from '../../../../utils/httpStatus';
import {
  validateDocument,
  validateEmail,
} from '../../../../services/backendPaymentsV2Services';
import { captureException } from './captureException';

export type CustomerAccountStatus = 'new' | 'existing' | 'conflict' | 'unknown';

type RegistrationStatus = 'free' | 'registered' | 'unknown';

type KnownRegistrationStatus = Exclude<RegistrationStatus, 'unknown'>;

const ACCOUNT_STATUS: Record<
  KnownRegistrationStatus,
  Record<KnownRegistrationStatus, CustomerAccountStatus>
> = {
  free: { free: 'new', registered: 'conflict' },
  registered: { free: 'conflict', registered: 'existing' },
};

const checkRegistration = async (
  request: Promise<unknown>,
): Promise<RegistrationStatus> => {
  try {
    await request;
    return 'free';
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === HttpStatus.CONFLICT) {
      return 'registered';
    }

    captureException('customer_account_check', error);
    return 'unknown';
  }
};

export const resolveCustomerAccount = async (
  email: string,
  document: string,
): Promise<CustomerAccountStatus> => {
  const [emailStatus, documentStatus] = await Promise.all([
    checkRegistration(validateEmail(email.trim())),
    checkRegistration(validateDocument(document.replace(/\D/g, ''))),
  ]);

  if (emailStatus === 'unknown' || documentStatus === 'unknown') return 'unknown';

  return ACCOUNT_STATUS[emailStatus][documentStatus];
};
